// Import Routes
import * as ROUTES from "../routes";

import Customers from "@/modules/customers/views"
import Customer from "@/modules/customers/views/customer"

const routes = [
    {
        path: ROUTES.CUSTOMERS,
        name: "Customers",
        component: Customers,
        meta: {
            title: "Customers",
            layout: "private",
            requiresAuth: true,
            nav: 'Customers',
            permissions: ['can_view_users']
        },
    },
    {
        path: ROUTES.CUSTOMER,
        name: "Customer",
        component: Customer,
        meta: {
            title: "Customer",
            layout: "private",
            requiresAuth: true,
            nav: 'Customers',
            permissions: ['can_view_users']
        }
    },
]

export default routes;